module.exports = __webpack_public_path__ + "static/media/RLVR_OLD.cbb1970a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/RLVR_OLD.jpg
// module id = 1377
// module chunks = 1